export interface DeviceDetails {
  ambulanceIdentifier: string
  ambulanceNumber: string
  emtPhone: string
  driverPhone: string
  proDeviceId: string
  ambulanceStatus: string
  mapId: number | undefined | null
  totalCount: number | undefined | null
  id: number | undefined | null
}

export interface DeviceForm {
  ambulanceIdentifier: string
  ambulanceNumber: string
  emtPhone: string
  driverPhone: string
  proDeviceId: string
  ambulanceStatus: string
  mapId: number | undefined | null
}

export interface ProrithmDevices {
  sNo: number
  bedId: number | undefined | null
  id: number | undefined | null
  locationName: string | undefined | null
  prorithmDeviceId: string
  roomId: number | undefined | null
  type: string | undefined | null
  wardId: number | undefined | null
}

export interface Wards {
  id: number | undefined | null
  floor_number: string | undefined | null
  ward_name: string | undefined | null
}

export interface Rooms {
  id: number
  room_name: string | undefined | null
  room_number: string | undefined | null
  ward_name: string | undefined | null
  ward_id: number | undefined | null
}

export interface Beds {
  id: number | undefined | null
  bed_number: string | undefined | null
  status: string | undefined | null
  patient_id: string | undefined | null
  room_name: string | undefined | null
  room_id: number | undefined | null
}

export interface AmbulanceDetails {
  ambulanceNumber: string | undefined | null
  location: string | undefined | null
  driverPhone: string | undefined | null
  emtPhone: string | undefined | null
}

export interface BedDetails {
  wardId: number | undefined | null
  wardName: string | undefined | null
  roomId: number | undefined | null
  roomName: string | undefined | null
  bedId: number | undefined | null
  bedName: string | undefined | null
}

export interface PatientsList {
  patientId: string
  patientName: string
  patientUhid: string
  patientAge: string
  patientGender: string
  phone: string
  mrNumber: string
}

export interface NewPatientForm {
  firstName: string
  lastName: string
  age: string
  gender: string
  phone: string
}

export interface IpdSearchOptions {
  admitStatus: string
  firstName: string
  lastName: string
  age: number
  gender: string
  muhId: string
  phoneNumber: string
  locationName: string | null
  bedType: string | null
  bedId: string | null
  bedName: string | null
  roomId: string | null
  roomName: string | null
  wardId: string | null
  wardName: string | null
}

export interface BedNumber {
  bed_number: string
  id: number
  location_id: string
}

export interface MapToLocationValues {
  location: string
  locationType: string
  locationPhone: string
}

export interface MapToIpdValues {
  location: string
  bedType: string
  ward: string
  room: string
  bed: string
}

export interface AmbulancePayload {
  categoryType: string
  patientId: string | null | undefined
  deviceId: string
  ambulance: {
    ambulanceVehicleNumber: string
    ambulanceLocation: string
    driverPhone: string
    emtNumber: string
  }
}

export interface HomekarePayload {
  categoryType: string
  patientId: string | null | undefined
  deviceId: string
  homekare: {
    executiveName: string
    executivePhoneNumber: string
  }
}

export interface IpdPayload {
  categoryType: string
  patientId: string | undefined
  deviceId: string
  ipd: {
    locationName: string
    wardId: string
    wardName: string | null | undefined
    roomId: string
    roomName: string | null | undefined
    bedId: string
    bedName: string | null | undefined
    bedType: string
  }
}

export interface LocationPayload {
  categoryType: string
  patientId: string | null | undefined
  deviceId: string
  location: {
    locationName: string
    locationType: string
    locationPhoneNumber: string
  }
}

export interface SmartRingRemapPayload {
  patientId: string
  deviceId: string
  deviceType: string
}

interface Location {
  locationName: string
  locationType: string
  locationPhoneNumber: string
}

interface Ambulance {
  driverPhone: string
  emtNumber: string
  ambulanceLocation: string
  ambulanceVehicleNumber: string
}

interface HomeKare {
  executiveName: string
  executivePhoneNumber: string
}

interface IPD {
  locationName: string
  wardId: string
  wardName: string
  roomId: string
  roomName: string
  bedId: string
  bedName: string
}

export interface ProrithmDeviceList {
  sNo: number
  mappingId: string | null
  deviceId: string
  deviceType?: string
  categoryType: string | null
  categoryId: string | null
  patientId: string | null
  status: string | null
  validFrom: string | null
  validTo: string | null
  location?: Location
  ambulance?: Ambulance
  homekare?: HomeKare
  ipd?: IPD
}

interface IpdMapping {
  locationName: string
  wardId: string
  wardName: string
  roomId: string
  roomName: string
  bedId: string
  bedName: string
  bedType: string
}

interface LocationMapping {
  locationName: string
  locationType: string
  locationPhoneNumber: string
}

interface HomekareMapping {
  executiveName: string
  executivePhoneNumber: string
}

interface AmbulanceMapping {
  driverPhone: string
  emtNumber: string
  ambulanceLocation: string
  ambulanceVehicleNumber: string
}

export interface DeviceMappingData {
  sNo: number
  mappingId: string | null
  deviceId: string
  deviceType: string | null
  categoryType: string | null
  categoryId: string | null
  patientId: string | null
  status: string | null
  validFrom: string | null
  validTo: string | null
  location?: LocationMapping
  ambulance?: AmbulanceMapping
  homekare?: HomekareMapping
  ipd?: IpdMapping
}

export interface ProrithmSocketMessage {
  messageType: string
  messageContent: {
    message: string
    macId: string
    category: string
  }
}

export const INTENT_GET_WARD_ROOM_BED_DETAILS = 'getWardRoomBedDetails'

export const endpoint = {
  addDevice: 'api/ipd/device/mappings',
  editProrithmMapping: 'api/ipd/device/mappings',
  getAllDevices: 'api/ipd/device/mappings',
  deleteDevice: 'api/ipd/device/mappings/',
  searchPatient: 'api/ipd/prorithm-bed-location-mapping/patient?',
  getBedsByLoc: 'api/ipd/prorithm-bed-location-mapping/beds?location=',
  createUIDPatient: 'api/ipd/unidentified-patient',
}

export const regex = {
  alphaNumerics: /^[a-zA-Z0-9]+$/,
  validPhone: /^[0-9]\d{9}$/,
  onlyNumerics: /^\d+$/,
  validDevice: /([A-Za-z0-9]{2}:){5}[A-Za-z0-9]{2}/,
}

export const mappingStatus = {
  notMapped: 'NOT_MAPPED',
  ipd: 'IPD',
  ipdStatus: 'Device already mapped to IPD',
  location: 'LOCATION',
  ambulance: 'AMBULANCE',
  homekare: 'HOMEKARE',
  homekareStatus: 'Device already mapped to Homekare',
  locationStatus: 'Device already mapped to Location',
  ambulanceStatus: 'Device already mapped to Ambulance',
  ringStatus: 'Smart Ring is already mapped to a patient',
}

export const constants = {
  mapDeviceLayout: 'mapDevice',
  ambulanceLayout: 'ambulance',
  addDevice: 'Add a device',
  ambulance: 'Ambulance',
  mapDevice: 'Map a device',
  close: 'Close',
  submit: 'Submit',
  location: 'LOCATION',
  available: 'AVAILABLE',
  selectLocation: 'Select Location',
  activeStatus: 'active',
  bedType: 'Bed Type',
  critical: 'Critical',
  nonCritical: 'Non-critical',
  selectWard: 'Select Ward',
  selectRoom: 'Select Room',
  selectBed: 'Select Bed',
  askDeleteDevice: 'Are you sure you want to delete mapping?',
  delete: 'Delete',
  cancel: 'Cancel',
  ipd: 'IPD',
  ambulanceText: 'AMBULANCE',
  no: 'No',
  yes: 'Yes',
  editMappedDevice: 'Edit mapped device',
  ambulanceDetails: 'Ambulance Details',
  deviceId: 'Device Id',
  ambulanceNumber: 'Ambulance Number',
  driverPhone: 'Driver Phone',
  emtPhone: 'EMT Phone',
  status: 'Status',
  locationText: 'Location',
  enterValidDeviceId: 'Enter valid device id',
  deviceIdHelperText: 'Device Id format: AB:CD:EF:GH:IJ:KL',
  smartRingHelperText: 'Device Id format: ABCD12345',
  deviceType: 'Device Type',
  prorithm: 'prorithm',
  smartRing: 'smartRing',
  enterValidSmartRingId: 'Please enter a valid alphanumeric device ID',
  active: 'ACTIVE',
  inactive: 'INACTIVE',
  category: 'Category',
  locationType: 'Location Type',
  mapPatient: 'Patient',
  existing: 'existing',
  new: 'new',
  unidentified: 'unidentified',
  selectGender: 'Select Gender',
  homekare: 'HOMEKARE',
  bedNumber: 'Bed Number',
  save: 'Save',
  openRegistration: 'Open Registration',
  mappingDetails: 'Mapping Details',
  patientDetails: 'Patient Details',
  firstName: 'First Name',
  lastName: 'Last Name',
  age: 'Age',
  gender: 'Gender',
  selectedPatient: 'Selected Patient',
  phone: 'Phone',
  all: 'ALL',
  byPatient: 'byPatient',
  byBed: 'byBed',
  add: 'ADD',
  deleteText: 'DELETE',
  update: 'UPDATE',
  notMapped: 'NOT_MAPPED',
  addMapping: 'addMapping',
  editMapping: 'editMapping',
  heartbeat: 'HEARTBEAT',
  loading: 'Loading. Please Wait...',
  selectPatient: 'Please Select a Patient',
  remapSmartRing: 'Remap Smart Ring',
  PRORITHM: 'PRORITHM',
  RING: 'RING',
}

export const messages = {
  deviceMappedSuccessfully: 'Device mapped successfully.',
  smartRingMappedSuccessfully: 'Smart Ring mapped successfully.',
  deviceDeletedSuccessfully: 'Device mapping inactivated.',
  deviceAddedSuccessfully: 'Device added successfully.',
  failedToAddDevice: 'Failed to add device. Please try again.',
  mappingAlreadyExistsError:
    'Network error or Mapping to this device already exists',
  getAllDevicesError: 'Failed to get devices.',
  checkMappingStatusError: 'Failed to get device mapping status.',
  deleteDeviceFailed: 'Failed to delete device.',
  ambDetailsError: 'Failed to get ambulance details.',
  ambulanceNumberInvalid: 'Only alphanumerics are allowed.',
  locationRequired: 'Location is required',
  phoneInvalid: 'Only 10 digits numerics allowed',
  statusRequired: 'Status is required',
  searchPatientError: 'Failed to search for your query.',
  bedDetailsError: 'Failed to get bed details',
  noBedsError: 'Failed to get beds based on location.',
  ageInvalid: 'Only valid numerics are allowed.',
  failedToMapDevice: 'Failed to map device. Please try again.',
  createUIDPatientError: 'Failed to create unidentified patient.',
  createUIDPatientSuccess: 'Unidentified patient created successfully.',
  patientIdNotFound: 'Patient ID not found',
  bedTypeRequired: 'Bed type is required',
  wardRequired: 'Ward is required',
  roomRequired: 'Room is required',
  bedRequired: 'Bed is required',
  ageRequired: 'Age is required',
  genderRequired: 'Gender is required',
  patientNotFound: 'Patient not found for the selected bed',
  noPatient: 'No patients found.',
  noPatientInIpd:
    'No patients found. Please register in IPD and allocate a bed to continue.',
  formRenderFailed: 'Failed to render form.',
  websocketConnection: 'WebSocket connection: ',
  websocketError: 'WebSocket error observed: ',
  websocketClosed: 'WebSocket closed with code: ',
  websocketClosedAbnormally:
    'WebSocket closed abnormally. Reconnecting to WebSocket server...',
  websocketConnectionClosed: 'WebSocket connection closed.',
  websocketCloseError: 'Error while closing existing WebSocket:',
  websocketNotOpen: 'WebSocket is not open. Message not sent:',
}

export const locationTypes = [
  { value: 'teleClinic', label: 'Tele-Clinic' },
  { value: 'a&eCenter', label: 'A&E Center' },
  { value: 'superSpeciality', label: 'Super Speciality' },
]

export const genderList = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
]

export const IPD_SEARCH_TERMS = [
  { label: 'MUHID', value: 'muhId' },
  { label: 'Name', value: 'name' },
  { label: 'Mobile', value: 'mobile' },
  // { label: 'Bed', value: 'status' },
]

export const paginationOptions = [20, 40, 60, 80, 100]

export const DEVICE_TYPE_OPTIONS = [
  { value: constants?.PRORITHM, label: 'Prorithm' },
  { value: constants?.RING, label: 'Smart Ring' },
]
